'use client'

import { useTranslations } from 'next-intl'
import {
  AuthDemoFooter,
  AuthDivider,
  AuthField,
  AuthGoogleButton,
  AuthHeading,
  AuthPasswordField,
  AuthPrimaryButton,
} from '@/components/auth/auth-form-primitives'
import { AuthShell } from '@/components/auth/auth-shell'

export function LoginCheckingState() {
  const t = useTranslations('Auth')
  const tPage = useTranslations('PageTitles')

  return (
    <AuthShell>
      <form
        aria-busy="true"
        style={{ display: 'flex', flexDirection: 'column', gap: '32px', opacity: 0.72 }}
      >
        <AuthHeading subtitle={t('signInToContinue')} title={tPage('welcomeBack')} />

        <AuthField
          disabled
          id="email-loading"
          label={t('emailLabel')}
          placeholder={t('emailPlaceholder')}
          type="email"
        />

        <AuthPasswordField
          disabled
          id="password-loading"
          label={t('passwordLabel')}
          placeholder={t('passwordPlaceholder')}
          showToggle={false}
        />

        <AuthPrimaryButton disabled type="button">
          {t('signIn')}
        </AuthPrimaryButton>

        <AuthDivider label={t('orContinueWith')} />

        <AuthGoogleButton disabled label={t('google')} type="button" />

        <AuthDemoFooter href="/signup" linkLabel={t('signUp')} prompt={t('dontHaveAccount')} />
      </form>
    </AuthShell>
  )
}
